import React from "react";
import Project from "./index";

export function ProjectPlanned() {
  return <Project status="Planifié" />;
}